import { Outlet, createRootRouteWithContext } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';

import { Toaster } from '@/components/ui/sonner';
import type { AuthStatus } from '@/features/auth/auth.store';

/**
 * Router context shared with every route. `authStatus` is read by route-level
 * `beforeLoad` guards to decide whether to redirect unauthenticated users to
 * `/sign-in`.
 */
export interface RouterContext {
  authStatus: AuthStatus;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
});

function RootComponent() {
  return (
    <>
      <Outlet />
      <Toaster />
      {import.meta.env.DEV && <TanStackRouterDevtools position="bottom-right" />}
    </>
  );
}
